import { render, staticRenderFns } from "./ClientesEditar.vue?vue&type=template&id=9072013e"
import script from "./ClientesEditar.vue?vue&type=script&lang=js"
export * from "./ClientesEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports